import RectangularSkeleton from "@shared/components/skeleton/RectangleSkeleton";

const CategorySkeleton = () => {
  return (
    <div className="flex items-center justify-between py-1.5  px-2  bg-fds-primary rounded-8 md:rounded-12 gap-3  border animate-pulse">
      <div className="flex items-center gap-2  overflow-hidden w-full">
        <RectangularSkeleton
          height={48}
          width={64}
          className=" rounded-4 flex-shrink-0"
        />
        <RectangularSkeleton height={16} width={200} className=" rounded" />
      </div>
      <RectangularSkeleton height={12} width={90} className=" rounded-6" />
    </div>
  );
};
export default CategorySkeleton;
